// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface ContentProps extends OptionalHtmlProps {
}

function getClassName(className: string) {
    var classNames = 'content-control ctnt-main';
    if (className !== undefined && className.length > 0) {
        classNames += ' ' + className;
    }
    return classNames
}

const Content = (props: ContentProps) => (
    <div style={props.styles} className={getClassName(props.class)}>
        {props.children}
    </div>
);

export default Content;